<template>
	<div>
		<HeadIndex></HeadIndex>
		
		<el-row>
			<el-col :span="24">
				<el-carousel  height="600px">
					<el-carousel-item >
						<img src="../../assets/img/banner2.jpg" width="100%" alt="">
					</el-carousel-item>
					<el-carousel-item >
						<img src="../../assets/img/index.jpg" width="100%" alt="">
					</el-carousel-item>
					<el-carousel-item >
						<img src="../../assets/img/login_bg.jpg" width="100%" alt="">
					</el-carousel-item>
				</el-carousel>
			</el-col>
		</el-row>
		<el-row class="logo_m">
			<el-col :span="24">
				<div>
					CopyRight © 脱手网 2018 苏ICP备18008659号
				</div>
			</el-col>
		</el-row>
	</div>
</template>
<script>
import '../../assets/index/index.css' //优化表格样式
import HeadIndex from '../public/HeadIndex';
import { Search } from '@element-plus/icons-vue'
export default {
	name: 'index',
	components: {
		HeadIndex,
		Search
	},
	data() {

		return {}
	},
	props: [],

	updated() {

	},


	mounted() {

	},

	activated() {

	},
	created() {
		this.hits();
	},
	watch: {

	},
	methods: {
		async hits() {
			await this.$axios.post('/api/yunsys.Website/hits').then(async (res) => {
				})
				.catch(err => {
				})
		}
	}
}
</script>
<style lang="less" scoped>
:deep(.el-input-group__append) {

	background: #ff8a5c;
}
</style>